import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallFinished extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallFinished";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallFinishedCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        AbstractWebRtcCall.setIncomingCalls(
            AbstractWebRtcCall.incomingCalls.value.filter(
                call => {
                    let keep = call.getId() != payload.callId;
                    if (!keep) {
                        call.destroy();
                    }
                    return keep;
                }
            )
        );
        AbstractWebRtcCall.create(payload.callId)!.onFinishCall();
        if (currentCall?.getId() == payload.callId) {
            AbstractWebRtcCall.setCurrentCall(undefined);
        }
    }

}